import fhirExtensionUrls from '@rs-core/fhir/extension/fhirExtensionUrls';
import { logDebug } from '@rs-core/utils/logger';

export const createPractitionerSlice = set => ({
	practitionerSignature: undefined,
	proxySignature: null,
	proxyUser: null,
	practitioner: undefined,
	practitioners: [],
	practitionerRoles: [],
	practionerLoaded: false,
	proxyPractionerLoaded: false,
	isReferringPhysician: false,

	setPractitionerSignature: signature => {
		logDebug('createPractitionerSlice', 'setPractitionerSignature', signature);
		set(() => ({ practitionerSignature: signature }));
	},
	setProxySignature: signature => {
		logDebug('createPractitionerSlice', 'setProxySignature', signature);
		set({ proxySignature: signature });
	},
	setProxyUser: user => set({ proxyUser: user }),
	setPractitioner: practitioner => {
		logDebug('createPractitionerSlice', 'setPractitioner', practitioner);
		const practitionerUserType = (practitioner?.extension || []).find(
			ext => ext.url === fhirExtensionUrls.practitioner.userType
		);
		const isReferringPhysicianType = (practitionerUserType?.extension || []).find(
			ext => ext.url === fhirExtensionUrls.practitioner.userTypeIsReferringPhysician
		);
		set({
			practitioner,
			isReferringPhysician: Boolean(isReferringPhysicianType?.valueBoolean),
		});
	},
	setPractitioners: practitioners => set({ practitioners }),
	setPractitionerRoles: roles => set({ practitionerRoles: roles }),
	setPractionerLoaded: loaded => set({ practionerLoaded: loaded }),
	setProxyPractionerLoaded: loaded => set({ proxyPractionerLoaded: loaded }),

	resetPractitionerStore: () =>
		set({
			practitionerSignature: undefined,
			proxySignature: null,
			proxyUser: null,
			practitioner: undefined,
			practitioners: [],
			practitionerRoles: [],
			practionerLoaded: false,
			proxyPractionerLoaded: false,
			isReferringPhysician: false,
		}),
});
